import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RedirectErrors } from '../../models/redirect-errors.enum';

@Component({
  selector: 'app-end-of-world',
  templateUrl: './end-of-world.component.html',
  styleUrls: ['./end-of-world.component.css'],
})
export class EndOfWorldComponent implements OnInit {
  errorMessage: string = '';
  msg: string = '';
  constructor(private translator: TranslateService) {}

  ngOnInit(): void {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let errorType = urlSearchParams.get('error');
    this.msg = urlSearchParams.get('message');

    this.setErrorMessage(Number(errorType));
  }

  setErrorMessage(errorType: number) {
    if (errorType === RedirectErrors.NoOrgAssigned) {
      this.translator.get('redirect no org').subscribe((val) => {
        this.errorMessage = val;
      });
      return;
    }
    if (errorType === RedirectErrors.NoAccess) {
      this.translator.get('redirect no access').subscribe((val) => {
        this.errorMessage = val;
      });
      return;
    }
    if (errorType === RedirectErrors.NotFound) {
      this.translator.get('redirect not found').subscribe((val) => {
        this.errorMessage = val;
      });
      return;
    }
  }
}
